module.exports = __webpack_public_path__ + "static/img/xsh.76c4cf53.png";